import { ModelBase } from '../../core/model/model-base';
import { HomepalDashboardMenuItemModel } from './homepal-dashboard-menu-item-model';

export class HomepalDashboardMenuModel extends ModelBase {
  constructor(dataContext?: any) {
    super();
    if (dataContext) {
      this.expiresInSeconds = dataContext.expiresInSeconds;

      if (Array.isArray(dataContext.dashboards)) this.dashboards = dataContext.dashboards.map(d => new HomepalDashboardMenuItemModel(d));
    }
  }

  expiresInSeconds: number;
  dashboards: HomepalDashboardMenuItemModel[] = [];
}
